<div class="wrapper holder">
    <div class="container">
        <div class="header-action buttons-grp">
            <mat-tab-group
                [selectedIndex]="(advanceViewTab$ | async) === advanceSetupTabs.accountSetup ? 0 : 1"
                (selectedIndexChange)="advanceViewTab$.next($event === 0 ? advanceSetupTabs.accountSetup : advanceSetupTabs.imageAds)">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span porAddFeature [featureName]="'accountSetup'">{{ 'Settings' | translate }}</span>
                    </ng-template>
                </mat-tab>
                @if (versionService.isAdvanceVersion()) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span porAddFeature [featureName]="'imagesAds'">{{ 'Images/Ads' | translate }}</span>
                    </ng-template>
                </mat-tab>
                }
            </mat-tab-group>
        </div>

        @if ((advanceViewTab$ | async) === advanceSetupTabs.accountSetup) {
        <p>{{ 'adminConsumerPortalHeading' | translate }}</p>
        @if (showWysiwyg) {
        <p>{{ 'adminConsumerPortalSubHeading' | translate }}</p>
        }

        <! -- Onboarding Section -->
        @if (onboardingConfig$ | async; as config) { @if (config.isPointOfRentalEmail && !isOnboarded()) {
        <div class="onboarding-section">
            <por-cp-onboard-panel
                [orgId]="config.organizationId"
                [email]="config.userEmail"
                [isProduction]="config.isProduction"
                [configCredentials]="{ cognitoToken: config.cognitoToken, relationshipId: config.relationshipId }"></por-cp-onboard-panel>
        </div>
        } }

        <form class="form-wrapper mt-2" [formGroup]="mandatoryForm" (ngSubmit)="onSubmit()">
            <mat-accordion>
                <mat-expansion-panel expanded>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'urlSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'urlSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">link</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="setup-cards-row">
                        <mat-card class="setup-card" appearance="outlined">
                            <mat-card-header>
                                <h2>
                                    {{ 'adminChooseYourUrl' | translate }}
                                    <button
                                        type="button"
                                        class="url-info-trigger"
                                        cdkOverlayOrigin
                                        #urlInfoTrigger="cdkOverlayOrigin"
                                        [attr.aria-expanded]="isUrlInfoOverlayOpen"
                                        [attr.aria-label]="('MoreInformationAbout' | translate) + ' ' + ('adminChooseYourUrl' | translate)"
                                        (click)="toggleUrlInfoOverlay()">
                                        <span porIcon icon="info"></span>
                                    </button>
                                    <por-overlay
                                        [layout]="'tooltip-panel'"
                                        [featureName]="'admin-choose-url-info'"
                                        [isOpen]="isUrlInfoOverlayOpen"
                                        [trigger]="urlInfoTrigger"
                                        (closeOverlayClick)="toggleUrlInfoOverlay()">
                                        <p>{{ 'adminChooseYourUrlSubHeading' | translate }}</p>
                                    </por-overlay>
                                </h2>
                            </mat-card-header>
                            <mat-card-content>
                                <ng-container>
                                    <p>
                                        {{ 'adminChooseYourUrlHeading' | translate }}
                                        <br />
                                        <span class="url-preview-text">{{ vanityUrl ? vanityUrl.value : '___' }}.{{ domain }}</span>
                                    </p>
                                </ng-container>
                                <ng-container *ngIf="!isFeatureForceHidden('AssetTags') && mandatoryForm.get('enableAssetTags')?.value">
                                    <div class="asset-tag-vanity-url-warning">
                                        <p>
                                            {{ 'AssetTagVanityUrlWarning' | translate }}
                                        </p>
                                    </div>
                                </ng-container>
                                <div class="form-group form-group-space vanity-url-preview">
                                    <span class="label-url">
                                        {{ 'adminChooseYourUrlPara1' | translate }}
                                        <button
                                            type="button"
                                            class="url-info-trigger"
                                            cdkOverlayOrigin
                                            #urlValidEntriesTrigger="cdkOverlayOrigin"
                                            [attr.aria-expanded]="isUrlValidEntriesOverlayOpen"
                                            [attr.aria-label]="('MoreInformationAbout' | translate) + ' ' + ('adminChooseYourUrlValidEntries' | translate)"
                                            (click)="toggleUrlValidEntriesOverlay()">
                                            <span porIcon icon="info"></span>
                                        </button>
                                        <por-overlay
                                            [layout]="'tooltip-panel'"
                                            [featureName]="'admin-choose-url-valid-entries-info'"
                                            [isOpen]="isUrlValidEntriesOverlayOpen"
                                            [trigger]="urlValidEntriesTrigger"
                                            (closeOverlayClick)="toggleUrlValidEntriesOverlay()">
                                            <p class="validEntriesText">
                                                {{ 'adminChooseYourUrlValidEntries' | translate }}
                                                <br />
                                                {{ 'adminChooseYourUrlValidEntries1' | translate }}
                                                <br />
                                                {{ 'adminChooseYourUrlValidEntries2' | translate }}
                                                <br />
                                                {{ 'adminChooseYourUrlValidEntries3' | translate }}
                                            </p>
                                        </por-overlay>
                                    </span>
                                    <div class="flex">
                                        <apx-form-field
                                            [classList]="'required flex-row spinner-holder'"
                                            [error]="vanityUrl?.invalid && (vanityUrl?.dirty || vanityUrl?.touched) ?
                                            vanityUrl?.errors?.['required'] ? ('RequiredError' | translate) :
                                            vanityUrl?.errors?.['noCom'] ? ('NoComError' | translate) :
                                            vanityUrl?.errors?.['unavailable'] ? ('UnavailableDomainError' | translate) :
                                            vanityUrl?.errors?.['noSpace'] ? ('spaceNotAllowed' | translate) :
                                            vanityUrl?.errors?.['badFormat'] ? ('badFormatError' | translate) :
                                            ''
                                            : '' ">
                                            <input
                                                apxInput
                                                type="text"
                                                placeholder="{{ 'adminChooseYourUrlInputPlaceholder' | translate }}"
                                                id="vanityUrl"
                                                formControlName="vanityUrl"
                                                [ngModel]="mandatoryForm.value.vanityUrl" />
                                            @if (!vanityUrl?.invalid) {
                                            <div class="flex-row mt-xs px-xs">
                                                <div class="flex items-center justify-center text-success">
                                                    <p class="p-none m-none">
                                                        &nbsp; @if ((vanityUrlAvailable$ | async) === true && (vanityUrlLoading$ | async) === false) {
                                                        <span>{{ 'adminChooseYourUrlDomainAvailable' | translate }}</span>
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                            } @if (vanityUrlLoading$ | async) {
                                            <span porIcon icon="spinner" class="spinner flex-row"></span>
                                            }
                                        </apx-form-field>
                                        <div class="flex-row hint-text url-preview">.{{ domain }}</div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="setup-card" appearance="outlined" *ngIf="!isFeatureForceHidden('AssetTags') && mandatoryForm.get('enableAssetTags')?.value">
                            <mat-card-header>
                                <h2>
                                    {{ 'AssetTagBaseUrlTitle' | translate }}
                                </h2>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="form-group-container">
                                    <div class="asset-tag-base-url-info-container">
                                        <span class="url-preview-text">{{ assetTagBaseUrl() }}</span>
                                        <por-base-button type="button" (onclick)="copyAssetTagBaseUrl()" class="ml-2">
                                            <mat-icon>content_copy</mat-icon>
                                            {{ 'Copy' | translate }}
                                        </por-base-button>
                                    </div>
                                    <div class="asset-tag-base-url-info">
                                        <div class="paragraph">
                                            <div>
                                                <b>{{ 'AssetTagBaseUrlLabel' | translate }}</b>
                                            </div>
                                            <div>{{ 'AssetTagBaseUrlInfo' | translate }}</div>
                                        </div>

                                        <div class="paragraph">
                                            <div>
                                                <b>{{ 'AssetTagInstructionsLabel' | translate }}</b>
                                            </div>
                                            <div>{{ 'AssetTagInstructions1' | translate }}</div>
                                            <div>{{ 'AssetTagInstructions2' | translate }}</div>
                                            <div>{{ 'AssetTagInstructions3' | translate }}</div>
                                        </div>

                                        <div class="paragraph">
                                            <div>
                                                <b>{{ 'AssetTagExampleLabel' | translate }}</b>
                                            </div>
                                            <div>{{ 'AssetTagExample1' | translate }}</div>
                                            <div>{{ 'AssetTagExample2' | translate }}</div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    @if (versionService.isBasicExternalConsumerPortalURL()) {
                    <div class="form-section">
                        <h2>
                            {{ 'ExternalConsumerPortalURL' | translate }}
                        </h2>
                        <div class="form-group-container">
                            <div class="form-group form-group-space">
                                <apx-form-field
                                    [error]="externalConsumerPortalURL && externalConsumerPortalURL.invalid && (externalConsumerPortalURL.dirty || externalConsumerPortalURL.touched) ?
                                    externalConsumerPortalURL.errors?.['invalidUrl'] ? ('InvalidUrl' | translate) :
                                    ''
                                    : '' ">
                                    <input
                                        apxInput
                                        type="email"
                                        placeholder="{{ 'EnterUrl' | translate }}"
                                        formControlName="externalConsumerPortalURL"
                                        [ngModel]="mandatoryForm.value.externalConsumerPortalURL" />
                                </apx-form-field>
                            </div>
                        </div>
                    </div>
                    }
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'brandingSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'brandingSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">palette</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-section">
                        <h2>{{ 'Primary' | translate }}:</h2>
                        <div class="form-group-container">
                            <div class="form-group">
                                <apx-form-field
                                    [classList]="'required flex-row'"
                                    [error]="primaryColor?.invalid && (primaryColor?.dirty || primaryColor?.touched) ?
                                    primaryColor?.errors?.['required'] ? ('RequiredError' | translate) :
                                    primaryColor?.errors?.['hex'] ? ('HexValid' | translate) :
                                    ''
                                    : '' ">
                                    <div class="color-picker-input">
                                        <input
                                            apxInput
                                            placeholder="{{ 'Pick or enter hex #' | translate }}"
                                            [ngModel]="mandatoryForm.value.primaryColor"
                                            [colorPicker]="selectedPrimaryColor"
                                            (colorPickerChange)="setColor('primaryColor', $event)"
                                            formControlName="primaryColor"
                                            cpOutputFormat="hex" />
                                        <div class="selected-color-preview bg-primary"></div>
                                    </div>
                                </apx-form-field>
                                <div class="hint-text ml-2">
                                    {{ 'adminPrimaryColorHint' | translate }}
                                </div>
                            </div>
                        </div>
                        <h2>{{ 'Secondary' | translate }}:</h2>
                        <div class="form-group-container">
                            <div class="form-group">
                                <apx-form-field
                                    [classList]="'required flex-row'"
                                    [error]="secondaryColor?.invalid && (secondaryColor?.dirty || secondaryColor?.touched) ?
                                    secondaryColor?.errors?.['required'] ? ('RequiredError' | translate) :
                                    secondaryColor?.errors?.['hex'] ? ('HexValid' | translate) :
                                    ''
                                    : '' ">
                                    <div class="color-picker-input">
                                        <input
                                            apxInput
                                            placeholder="{{ 'Pick or enter hex #' | translate }}"
                                            [ngModel]="mandatoryForm.value.secondaryColor"
                                            [colorPicker]="selectedSecondaryColor"
                                            (colorPickerChange)="setColor('secondaryColor', $event)"
                                            formControlName="secondaryColor"
                                            cpOutputFormat="hex" />
                                        <div class="selected-color-preview bg-secondary"></div>
                                    </div>
                                </apx-form-field>
                                <div class="hint-text ml-2">
                                    {{ 'adminSecondaryColorHint' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="setup-cards-row">
                        <mat-card class="setup-card" appearance="outlined">
                            <mat-card-header>
                                <h2 class="logo-section-title">
                                    {{ 'logo' | translate }}
                                    <button
                                        type="button"
                                        class="logo-info-trigger"
                                        cdkOverlayOrigin
                                        #logoInfoTrigger="cdkOverlayOrigin"
                                        [attr.aria-expanded]="isLogoInfoOverlayOpen"
                                        [attr.aria-label]="('MoreInformationAbout' | translate) + ' ' + ('logo' | translate)"
                                        (click)="toggleLogoInfoOverlay()">
                                        <span porIcon icon="info"></span>
                                    </button>
                                </h2>
                                <por-overlay
                                    [layout]="'tooltip-panel'"
                                    [featureName]="'logo-info'"
                                    [isOpen]="isLogoInfoOverlayOpen"
                                    [trigger]="logoInfoTrigger"
                                    (closeOverlayClick)="toggleLogoInfoOverlay()">
                                    <p class="hint-text">
                                        {{ 'adminLogoUrlHintSize' | translate }}
                                        <br />
                                        {{ 'adminLogoUrlHint' | translate }}
                                    </p>
                                </por-overlay>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="form-group-container">
                                    <div class="form-group logo-url-input">
                                        <div class="hint-text">{{ 'LogoRedirectUrlText' | translate }}</div>
                                        <apx-form-field
                                            [error]="logoRedirectUrl?.invalid && (logoRedirectUrl?.dirty || logoRedirectUrl?.touched) ?
                                            logoRedirectUrl?.errors?.['invalidUrl'] ? ('InvalidUrl' | translate) :
                                            ''
                                            : '' ">
                                            <input apxInput type="text" placeholder="{{ 'EnterURL' | translate }}" formControlName="logoRedirectUrl" [ngModel]="mandatoryForm.value.logoRedirectUrl" />
                                        </apx-form-field>
                                    </div>
                                    <por-ad-drag-drop
                                        (uploadSuccess)="handleFile($event, fileType.Logo)"
                                        [allowedExtensions]="logoAllowedExtensions"
                                        [currentImage]="$any(mandatoryForm.value)?.logoUrl"></por-ad-drag-drop>
                                    @if (!isFeatureForceHidden('AiGenerateImages')) {
                                    <por-base-button class="ai-generate-button" porAdDragExtraActions (onclick)="openAiDialog()" [featureName]="'ai-generate-image-logo'">
                                        {{ 'aiImageGenerateButton' | translate }}
                                    </por-base-button>
                                    } @if (logoUrl?.invalid && logoUrl?.errors) {
                                    <div class="error logo-error-holder mt-xs px-xs ng-star-inserted">
                                        <div class="logo-error text-error ng-star-inserted">
                                            <p class="p-none m-none">{{ 'invalidLogoFormat' | translate }}</p>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="setup-card" appearance="outlined">
                            <mat-card-header>
                                <h2 class="icon-section-title">
                                    {{ 'icon' | translate }}
                                    <button
                                        type="button"
                                        class="icon-info-trigger"
                                        cdkOverlayOrigin
                                        #iconInfoTrigger="cdkOverlayOrigin"
                                        [attr.aria-expanded]="isIconInfoOverlayOpen"
                                        [attr.aria-label]="('MoreInformationAbout' | translate) + ' ' + ('icon' | translate)"
                                        (click)="toggleIconInfoOverlay()">
                                        <span porIcon icon="info"></span>
                                    </button>
                                </h2>
                                <por-overlay
                                    [layout]="'tooltip-panel'"
                                    [featureName]="'icon-info'"
                                    [isOpen]="isIconInfoOverlayOpen"
                                    [trigger]="iconInfoTrigger"
                                    (closeOverlayClick)="toggleIconInfoOverlay()">
                                    <p class="hint-text">
                                        {{ 'adminFaviconUrlHintSize' | translate }}
                                        <br />
                                        {{ 'adminFaviconUrlHint' | translate }}
                                    </p>
                                </por-overlay>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="form-group-container">
                                    <por-ad-drag-drop (uploadSuccess)="handleFile($event, fileType.Icon)" [currentImage]="$any(mandatoryForm.value)?.faviconUrl" />
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    @if (showWysiwyg) {
                    <por-admin-wysiwyg [adminConfig]="adminConfig" [logoUrl]="mandatoryForm.value.logoUrl"></por-admin-wysiwyg>
                    }
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'storeSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'storeSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">storefront</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-section">
                        <h2>{{ 'adminStoreName' | translate }}</h2>
                        <div class="form-group-container">
                            <div class="form-group">
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="storeName?.invalid && (storeName?.dirty || storeName?.touched) ?
                                    storeName?.errors?.['required'] ? ('RequiredError' | translate) :
                                    ''
                                    : '' ">
                                    <input
                                        apxInput
                                        type="text"
                                        placeholder="{{ 'adminStoreNameInputPlaceholder' | translate }}"
                                        formControlName="storeName"
                                        [ngModel]="mandatoryForm.value.storeName" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'adminStoreNameHeading' | translate }}</div>
                            </div>
                        </div>
                        <h2>{{ 'Language' | translate }}</h2>
                        <div class="form-group-container">
                            <div class="form-group">
                                <por-language-selector
                                    class="selector-width"
                                    (selectedLocale)="handleSelectedLocale($event)"
                                    [options]="languageOptions"
                                    [selectedLanguageOption]="mandatoryForm.value.locale ?? ''"></por-language-selector>
                                <div class="hint-text ml-2">{{ 'LanguageHintText' | translate }}</div>
                            </div>
                        </div>
                        <h2>
                            {{ 'PrivacyPolicy' | translate }}
                        </h2>
                        <div class="form-group-container">
                            <div class="form-group-container d-inline-flex">
                                <div class="toogle-wrapper toggle-wrapper-section">
                                    <label>{{ 'EnablePrivacyPolicyText' | translate }}:</label>
                                    <por-base-toggle
                                        [parentForm]="mandatoryForm"
                                        [formControlName]="'enablePrivacyPolicy'"
                                        [model]="mandatoryForm.value.enablePrivacyPolicy"
                                        (modelChange)="onModelChange($event, 'enablePrivacyPolicy')"></por-base-toggle>
                                </div>
                                <div class="hint-text ml-2">{{ 'EnablePrivacyPolicyHintText' | translate }}</div>
                            </div>
                            <div class="form-group">
                                <apx-form-field
                                    [error]="privacyUrl?.invalid && (privacyUrl?.dirty || privacyUrl?.touched) ?
                                    privacyUrl?.errors?.['invalidUrl'] ? ('InvalidUrl' | translate) :
                                    ''
                                    : '' ">
                                    <input apxInput type="text" placeholder="{{ 'EnterURL' | translate }}" formControlName="privacyUrl" [ngModel]="mandatoryForm.value.privacyUrl" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'PrivacyPolicyURLText' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'emailSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'emailSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">mail</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <! -- SMTP Configuration Section (Feature Wrapped) -->
                    <div class="form-section" *ngIf="!isFeatureForceHidden('CustomSmtp')">
                        <h2>{{ 'BusinessEmailSetup' | translate }}</h2>
                        <div class="form-group-container">
                            <span class="spinner-holder spinner-space" *ngIf="!isSmtpConfigReady()">
                                <span porIcon icon="spinner" class="spinner position-relative"></span>
                            </span>
                            <div *ngIf="isSmtpConfigReady()">
                                <! -- Enable Toggle -->
                                <div class="form-group-container d-inline-flex">
                                    <div class="toogle-wrapper toggle-wrapper-section">
                                        <label>{{ 'EnableBusinessEmail' | translate }}:</label>
                                        <por-base-toggle
                                            [parentForm]="mandatoryForm"
                                            [formControlName]="'smtpEnabled'"
                                            [model]="mandatoryForm.get('smtpEnabled')?.value"
                                            (modelChange)="onModelChange($event, 'smtpEnabled')"></por-base-toggle>
                                    </div>
                                    <div class="hint-text ml-2">{{ 'BusinessEmailHelperText' | translate }}</div>
                                </div>

                                <! -- SMTP Fields (shown when enabled) -->
                                <div *ngIf="mandatoryForm.value.smtpEnabled">
                                    <! -- SMTP Host -->
                                    <div class="form-group multi-line smtp-field-row">
                                        <span class="smtp-field-label required">{{ 'SmtpHost' | translate }}:</span>
                                        <apx-form-field
                                            [classList]="'required'"
                                            [error]="smtpHost?.invalid && (smtpHost?.dirty || smtpHost?.touched) ?
                                                smtpHost?.errors?.['required'] ? ('RequiredError' | translate) : ''
                                                : ''">
                                            <input apxInput type="text" placeholder="{{ 'SmtpHostPlaceholder' | translate }}" formControlName="smtpHost" [ngModel]="mandatoryForm.value.smtpHost" />
                                        </apx-form-field>
                                        <div class="hint-text ml-2">{{ 'SmtpHostHint' | translate }}</div>
                                    </div>

                                    <! -- SMTP User -->
                                    <div class="form-group multi-line smtp-field-row">
                                        <span class="smtp-field-label required">{{ 'SmtpUser' | translate }}:</span>
                                        <apx-form-field
                                            [classList]="'required'"
                                            [error]="smtpUser?.invalid && (smtpUser?.dirty || smtpUser?.touched) ?
                                                smtpUser?.errors?.['required'] ? ('RequiredError' | translate) : ''
                                                : ''">
                                            <input apxInput type="text" placeholder="{{ 'SmtpUserPlaceholder' | translate }}" formControlName="smtpUser" [ngModel]="mandatoryForm.value.smtpUser" />
                                        </apx-form-field>
                                    </div>

                                    <! -- SMTP Password -->
                                    <div class="form-group multi-line smtp-field-row">
                                        <span class="smtp-field-label" [class.required]="!hasExistingSmtpConfig()">{{ 'SmtpPassword' | translate }}:</span>
                                        <apx-form-field
                                            [classList]="hasExistingSmtpConfig() ? '' : 'required'"
                                            [error]="smtpPassword?.invalid && (smtpPassword?.dirty || smtpPassword?.touched) ?
                                                smtpPassword?.errors?.['required'] ? ('RequiredError' | translate) : ''
                                                : ''">
                                            <input
                                                apxInput
                                                type="password"
                                                autocomplete="new-password"
                                                [placeholder]="hasExistingSmtpConfig() ? ('LeaveBlankToKeepCurrent' | translate) : ('SmtpPasswordPlaceholder' | translate)"
                                                formControlName="smtpPassword"
                                                [ngModel]="mandatoryForm.value.smtpPassword" />
                                        </apx-form-field>
                                    </div>

                                    <! -- SMTP Encryption -->
                                    <div class="form-group multi-line smtp-field-row">
                                        <span class="smtp-field-label">{{ 'SmtpEncryption' | translate }}:</span>
                                        <select class="smtp-select" formControlName="smtpEncryption">
                                            <option value="TLS">TLS ({{ 'Port' | translate }} 587)</option>
                                            <option value="SSL">SSL ({{ 'Port' | translate }} 465)</option>
                                            <option value="NONE">{{ 'None' | translate }} ({{ 'Port' | translate }} 25)</option>
                                        </select>
                                    </div>

                                    <! -- SMTP From Address -->
                                    <div class="form-group multi-line smtp-field-row">
                                        <span class="smtp-field-label required">{{ 'SmtpFromAddress' | translate }}:</span>
                                        <apx-form-field
                                            [classList]="'required'"
                                            [error]="smtpFromAddress?.invalid && (smtpFromAddress?.dirty || smtpFromAddress?.touched) ?
                                                smtpFromAddress?.errors?.['required'] ? ('RequiredError' | translate) :
                                                smtpFromAddress?.errors?.['email'] ? ('EmailValid' | translate) : ''
                                                : ''">
                                            <input
                                                apxInput
                                                type="email"
                                                placeholder="{{ 'SmtpFromAddressPlaceholder' | translate }}"
                                                formControlName="smtpFromAddress"
                                                [ngModel]="mandatoryForm.value.smtpFromAddress" />
                                        </apx-form-field>
                                        <div class="hint-text ml-2">{{ 'SmtpFromAddressHint' | translate }}</div>
                                    </div>

                                    <! -- Test Email Button -->
                                    <div class="form-group smtp-field-row">
                                        <span class="smtp-field-label">&nbsp;</span>
                                        <por-base-button type="button" (onclick)="handleTestEmailClick()" [disabled]="isTestEmailDisabled()">
                                            {{ getTestEmailButtonLabel() }}
                                        </por-base-button>
                                        <span class="spinner-holder spinner-space spinner-inline" *ngIf="isSmtpSaving() || isSmtpTesting()">
                                            <span porIcon icon="spinner" class="spinner position-relative"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    @if (versionService.isAdvanceVersion()) {
                    <div class="form-section">
                        <h2>{{ 'adminEnterRequestAction' | translate }}</h2>
                        <div class="form-group-container">
                            <div class="form-group form-group-space">
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="notificationEmail?.invalid && (notificationEmail?.dirty || notificationEmail?.touched) ?
                                        notificationEmail?.errors?.['required'] ? ('RequiredError' | translate) :
                                        notificationEmail?.errors?.['email'] ? ('EmailValid' | translate) :
                                        ''
                                        : '' ">
                                    <input
                                        apxInput
                                        type="email"
                                        placeholder="{{ 'Enter email address' | translate }}"
                                        formControlName="notificationEmail"
                                        [ngModel]="mandatoryForm.value.notificationEmail" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'adminNotificationEmailHint' | translate }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-section">
                        <h2>{{ 'AdminServiceRequestEmail' | translate }}</h2>
                        <div class="form-group-container">
                            <div class="form-group form-group-space">
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="serviceRequestEmail?.invalid && (serviceRequestEmail?.dirty || serviceRequestEmail?.touched) ?
                                        serviceRequestEmail?.errors?.['email'] ? ('EmailValid' | translate) :
                                        ''
                                        : '' ">
                                    <input
                                        apxInput
                                        type="email"
                                        placeholder="{{ 'Enter email address' | translate }}"
                                        formControlName="serviceRequestEmail"
                                        [ngModel]="mandatoryForm.value.serviceRequestEmail" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'AdminServiceRequestEmailHint' | translate }}</div>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="form-section">
                        <h2>
                            {{ 'EnterSupportEmailAddress' | translate }}
                        </h2>
                        <div class="form-group-container">
                            <div class="form-group form-group-space">
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="supportEmail?.invalid && (supportEmail?.dirty || supportEmail?.touched) ?
                                    supportEmail?.errors?.['required'] ? ('RequiredError' | translate) :
                                    supportEmail?.errors?.['email'] ? ('EmailValid' | translate) :
                                    ''
                                    : '' ">
                                    <input apxInput type="email" placeholder="{{ 'Enter email address' | translate }}" formControlName="supportEmail" [ngModel]="mandatoryForm.value.supportEmail" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'SupportEmailHint' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                @if (!isFeatureForceHidden('LiveTracking')) {
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'credentialSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'credentialSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">vpn_key</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-section">
                        <h2>
                            {{ 'HAPNCredentials' | translate }}
                            <button
                                type="button"
                                class="url-info-trigger"
                                cdkOverlayOrigin
                                #hapnInfoTrigger="cdkOverlayOrigin"
                                [attr.aria-expanded]="isHapnInfoOverlayOpen"
                                [attr.aria-label]="('MoreInformationAbout' | translate) + ' ' + ('HAPNCredentials' | translate)"
                                (click)="toggleHapnInfoOverlay()">
                                <span porIcon icon="info"></span>
                            </button>
                            <por-overlay
                                [layout]="'tooltip-panel'"
                                [featureName]="'hapn-credentials-info'"
                                [isOpen]="isHapnInfoOverlayOpen"
                                [trigger]="hapnInfoTrigger"
                                (closeOverlayClick)="toggleHapnInfoOverlay()">
                                <p>{{ 'ReceiveYourClientId' | translate }}</p>
                            </por-overlay>
                        </h2>
                        <div>
                            @if (!isExternalCredentialsReady()) {
                            <span class="spinner-holder spinner-space">
                                <span porIcon icon="spinner" class="spinner position-relative"></span>
                            </span>
                            } @if (isExternalCredentialsReady()) {
                            <div class="hapn-credentials-row">
                                <div class="hapn-field">
                                    <apx-form-field>
                                        <input apxInput type="text" placeholder="{{ 'EnterClientID' | translate }}" formControlName="hapnClientId" [ngModel]="mandatoryForm.value.hapnClientId" />
                                    </apx-form-field>
                                </div>
                                <div class="hapn-field">
                                    <apx-form-field>
                                        <input
                                            apxInput
                                            type="text"
                                            placeholder="{{ 'EnterClientSecret' | translate }}"
                                            formControlName="hapnClientSecret"
                                            [ngModel]="mandatoryForm.value.hapnClientSecret" />
                                    </apx-form-field>
                                </div>
                                <div class="hapn-action">
                                    <por-base-button type="button" (onclick)="testHapnConnection()">
                                        {{ 'TestHAPNConnection' | translate }}
                                    </por-base-button>
                                    @if (isLoadingTestHapn()) {
                                    <span class="spinner-holder spinner-inline">
                                        <span porIcon icon="spinner" class="spinner position-relative"></span>
                                    </span>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </mat-expansion-panel>
                }
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'paymentSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'paymentSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">payments</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-section">
                        <h2>
                            {{ 'SetupDefaultPaymentDepotStore' | translate }}
                        </h2>
                        <div class="form-group-container">
                            @if (!mandatoryForm.value.defaultPaymentMid) {
                            <div class="warning-callout">
                                <div class="warning-icon">
                                    <i class="material-icons">warning</i>
                                </div>
                                <div class="warning-text">
                                    {{ 'NoDefaultPaymentStoreSet' | translate }}
                                </div>
                            </div>
                            }
                            <div class="form-group">
                                @if (!isDefaultPaymentMidReady()) {
                                <span class="spinner-holder">
                                    <span porIcon icon="spinner" class="spinner position-relative"></span>
                                </span>
                                } @if (isDefaultPaymentMidReady()) {
                                <por-base-select
                                    label="Select"
                                    class="selector-width"
                                    [options]="defaultPaymentDepotOptions"
                                    (modelChange)="handleSelectDefaultPaymentDepot($event)"
                                    [formControlName]="'defaultPaymentMid'"
                                    [parentForm]="mandatoryForm"
                                    [model]="mandatoryForm.value.defaultPaymentMid ?? ''"
                                    porAddFeature
                                    featureName="default-payment-depot-selector"></por-base-select>
                                }
                                <div class="hint-text ml-2">
                                    <div class="help-info">
                                        <i class="material-icons help-icon">help</i>
                                        <span class="help-text">{{ 'DefaultPaymentStoreHelpText' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    @if (payMinimumAmountDueVisible) {
                    <div class="form-section radio-section">
                        <h2>
                            {{ 'SettingForInitialDepositPaymentText' | translate }}
                        </h2>
                        <div class="form-group-container">
                            <por-base-radio
                                [style]="'radioButtonBlock'"
                                [values]="[
                                    { text: 'MinimumPaymentDueAdmin' | translate, value: payMinimumAmountEnum.PayMinimumAmount.toString() },
                                    { text: 'InitialPaymentDueAdmin' | translate, value: payMinimumAmountEnum.InitialPaymentDue.toString() },
                                    { text: 'Other' | translate, value: payMinimumAmountEnum.Other.toString() }
                                ]"
                                formControlName="payMinimumAmountDueType"
                                (modelChange)="onPayMinimumAmountDueTypeChange($event)"
                                [model]="mandatoryForm.value.payMinimumAmountDueType"></por-base-radio>
                        </div>
                        <div class="form-group-container radio-asigned">
                            <apx-form-field
                                [error]="payMinimumAmountDueText && payMinimumAmountDueText.invalid && (payMinimumAmountDueText.dirty || payMinimumAmountDueText.touched) ?
                                payMinimumAmountDueText.errors?.['required'] ? ('RequiredError' | translate) :
                                payMinimumAmountDueText.errors?.['noSpecialCharacters'] ? ('InvalidSpecialCharacters' | translate) :
                                ''
                                : '' ">
                                <mat-label class="mini-label">{{ 'EnterText' | translate }}</mat-label>
                                <input
                                    apxInput
                                    type="text"
                                    placeholder="{{ 'InitialAmountToConfirmYourReservation' | translate }}"
                                    formControlName="payMinimumAmountDueText"
                                    [ngModel]="mandatoryForm.value.payMinimumAmountDueText"
                                    [disabled]="mandatoryForm.get('payMinimumAmountDueType')?.value !== payMinimumAmountEnum.Other.toString()" />
                            </apx-form-field>
                        </div>
                    </div>
                    } @if (!isFeatureForceHidden('InvoiceMultiPay')) {
                    <!-- Invoice Multi Pay Section (Feature Wrapped) -->
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'InvoiceMultiPayLabel' | translate }}</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'invoiceMultiPay'"
                                    [model]="mandatoryForm.value.invoiceMultiPay"
                                    (modelChange)="onModelChange($event, 'invoiceMultiPay')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'InvoiceMultiPayHintText' | translate }}</div>
                        </div>
                    </div>
                    } @if (!isFeatureForceHidden('TokenizeOnlyPayments')) {
                    <!-- Tokenize Only Payments Section (Feature Wrapped) -->
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'TokenizeOnlyPaymentsLabel' | translate }}</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'tokenizeOnlyPayments'"
                                    [model]="mandatoryForm.value.tokenizeOnlyPayments"
                                    (modelChange)="onModelChange($event, 'tokenizeOnlyPayments')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'TokenizeOnlyPaymentsHintText' | translate }}</div>
                        </div>
                    </div>
                    }
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'accessSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'accessSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">lock</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'SecureUrlLoginRequired' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'secureUrlLoginRequired'"
                                    [model]="mandatoryForm.value.secureUrlLoginRequired"
                                    (modelChange)="onModelChange($event, 'secureUrlLoginRequired')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'SecureUrlLoginRequiredHint' | translate }}</div>
                        </div>
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'MultiplePaymentAbilityText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'multiplePaymentAbility'"
                                    [model]="mandatoryForm.value.multiplePaymentAbility"
                                    (modelChange)="onModelChange($event, 'multiplePaymentAbility')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'MultiplePaymentAbilityHintText' | translate }}</div>
                        </div>
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'QuotesPaymentAbilityText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'quotesPaymentAbility'"
                                    [model]="mandatoryForm.value.quotesPaymentAbility"
                                    (modelChange)="onModelChange($event, 'quotesPaymentAbility')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'QuotesPaymentAbilityHintText' | translate }}</div>
                        </div>
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'ShowZeroQuantityItemsText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'showZeroQuantityItems'"
                                    [model]="mandatoryForm.value.showZeroQuantityItems"
                                    (modelChange)="onModelChange($event, 'showZeroQuantityItems')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'ShowZeroQuantityItemsHintText' | translate }}</div>
                        </div>
                    </div>
                    @if (versionService.isAdvanceVersion()) {
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'CallOffAbilityText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'callOffAbility'"
                                    [model]="mandatoryForm.value.callOffAbility"
                                    (modelChange)="onModelChange($event, 'callOffAbility')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'CallOffAbilityHintText' | translate }}</div>
                        </div>
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'RequestServiceAbilityText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'requestServiceAbility'"
                                    [model]="mandatoryForm.value.requestServiceAbility"
                                    (modelChange)="onModelChange($event, 'requestServiceAbility')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'RequestServiceAbilityHintText' | translate }}</div>
                        </div>
                        @if (!isFeatureForceHidden('LiveTracking')) {
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'LiveTrackingText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'liveTracking'"
                                    [model]="mandatoryForm.value.liveTracking"
                                    (modelChange)="onModelChange($event, 'liveTracking')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'LiveTrackingHintText' | translate }}</div>
                        </div>
                        }
                    </div>
                    } @if (versionService.hasLicense('ConsumerPortalTracking') && featureToggleService.isAvailable('canSeeTrackingTab')) {
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'TrackingTabText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'trackingTab'"
                                    [model]="mandatoryForm.value.trackingTab"
                                    (modelChange)="onModelChange($event, 'trackingTab')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'TrackingTabHintText' | translate }}</div>
                        </div>
                    </div>
                    } @if (!isFeatureForceHidden('AssetTags')) {
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'AssetTagToggleText' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'enableAssetTags'"
                                    [model]="mandatoryForm.value.enableAssetTags"
                                    (modelChange)="onModelChange($event, 'enableAssetTags')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'AssetTagToggleHintText' | translate }}</div>
                        </div>
                    </div>
                    } @if (featureToggleService.isExpert() && !isFeatureForceHidden('HideUnverifiedContracts')) {
                    <!-- Hide Unverified Contracts Section (Feature Wrapped, Elite only) -->
                    <div class="form-section">
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label porAddFeature [featureName]="'hideUnverifiedContractsLabel'">{{ 'HideUnverifiedContractsLabel' | translate }}</label>
                                <por-base-toggle
                                    [featureName]="'hideUnverifiedContracts'"
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'hideUnverifiedContracts'"
                                    [model]="mandatoryForm.value.hideUnverifiedContracts"
                                    (modelChange)="onModelChange($event, 'hideUnverifiedContracts')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2" porAddFeature [featureName]="'hideUnverifiedContractsHint'">{{ 'HideUnverifiedContractsHintText' | translate }}</div>
                        </div>
                    </div>
                    }
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'autoReservationSettings' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'autoReservationSettingsDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">autorenew</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <! -- Auto-Reservation Section (Feature Wrapped) -->
                    <div class="form-section">
                        @if (!isFeatureForceHidden('AutoConvertQuotes')) {
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label class="auto-convert-label">
                                    {{ 'AutoConvertQuotesLabel' | translate }}
                                </label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'autoConvertQuotes'"
                                    [model]="mandatoryForm.value.autoConvertQuotes"
                                    (modelChange)="onModelChange($event, 'autoConvertQuotes')"></por-base-toggle>
                            </div>
                            <por-overlay
                                [layout]="'tooltip-panel'"
                                [featureName]="'auto-convert-quotes-info'"
                                [isOpen]="isAutoConvertInfoOverlayOpen"
                                [trigger]="autoConvertInfoTrigger"
                                (closeOverlayClick)="toggleAutoConvertInfoOverlay()">
                                <p>
                                    {{ 'AutoConvertUnifiedNumberingHint' | translate }}
                                    <a href="https://por.my.site.com/uLearn/s/article/Unified-Numbering-Contract-Status-Change-445182718?language=en_US" target="_blank">
                                        {{ 'ReadMore' | translate }}
                                    </a>
                                </p>
                            </por-overlay>
                            <div class="hint-text ml-2">
                                {{ 'AutoConvertQuotesHintText' | translate }}
                                <button
                                    type="button"
                                    class="auto-convert-info-trigger"
                                    cdkOverlayOrigin
                                    #autoConvertInfoTrigger="cdkOverlayOrigin"
                                    [attr.aria-expanded]="isAutoConvertInfoOverlayOpen"
                                    [attr.aria-label]="('MoreInformationAbout' | translate) + ' ' + ('autoReservationSettings' | translate)"
                                    (click)="toggleAutoConvertInfoOverlay()">
                                    <span porIcon icon="info"></span>
                                </button>
                            </div>
                        </div>
                        }

                        <! -- eSign Required Section (Feature Wrapped) -->
                        @if (!isFeatureForceHidden('ESignRequired')) {
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'ESignRequiredLabel' | translate }}</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'eSignRequired'"
                                    [model]="mandatoryForm.value.eSignRequired"
                                    (modelChange)="onModelChange($event, 'eSignRequired')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'ESignRequiredHintText' | translate }}</div>
                        </div>
                        }

                        <! -- Payment Required Section (Feature Wrapped) -->
                        @if (!isFeatureForceHidden('PaymentRequired')) {
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label>{{ 'PaymentRequiredLabel' | translate }}</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'paymentRequired'"
                                    [model]="mandatoryForm.value.paymentRequired"
                                    (modelChange)="onModelChange($event, 'paymentRequired')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'PaymentRequiredHintText' | translate }}</div>
                        </div>
                        }

                        <! -- Complete Reservation Button Section (Feature Wrapped) -->
                        @if (!isFeatureForceHidden('CompleteReservationButton')) {
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper">
                                <label porAddFeature [featureName]="'completeReservationButtonLabel'">{{ 'CompleteReservationButtonLabel' | translate }}</label>
                                <por-base-toggle
                                    [featureName]="'completeReservationButton'"
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'completeReservationButton'"
                                    [model]="mandatoryForm.value.completeReservationButton"
                                    (modelChange)="onModelChange($event, 'completeReservationButton')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2" porAddFeature [featureName]="'completeReservationButtonHint'">{{ 'CompleteReservationButtonHintText' | translate }}</div>
                        </div>
                        }
                    </div>
                </mat-expansion-panel>
                @if (featureToggleService.isSyrinx()) {
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'DisplayCertificateConfig' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'DisplayCertificateConfigDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">verified</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-group-container d-inline-flex">
                        <div class="toogle-wrapper">
                            <label>{{ 'DisplayServiceCertificates' | translate }}:</label>
                            <por-base-toggle
                                [parentForm]="mandatoryForm"
                                [formControlName]="'displayServiceCertificate'"
                                [model]="mandatoryForm.value.displayServiceCertificate"
                                (modelChange)="onModelChange($event, 'displayServiceCertificate')"></por-base-toggle>
                        </div>
                        <div class="hint-text ml-2">{{ 'DisplayServiceCertificatesHint' | translate }}</div>
                    </div>
                    <div class="form-group-container d-inline-flex">
                        <div class="toogle-wrapper">
                            <label>{{ 'DisplayInspectionDocument' | translate }}:</label>
                            <por-base-toggle
                                [parentForm]="mandatoryForm"
                                [formControlName]="'displayInspectionDocument'"
                                [model]="mandatoryForm.value.displayInspectionDocument"
                                (modelChange)="onModelChange($event, 'displayInspectionDocument')"></por-base-toggle>
                        </div>
                        <div class="hint-text ml-2">{{ 'DisplayInspectionDocumentHint' | translate }}</div>
                    </div>
                </mat-expansion-panel>
                } @if (featureToggleService.isExpert() && !isFeatureForceHidden('AutomatedOffRentAndService')) {
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'NotificationsTitle' | translate }}</mat-panel-title>
                        <mat-panel-description class="panel-description-with-icon">
                            {{ 'NotificationsTitleDescription' | translate }}
                            <mat-icon aria-hidden="true" class="panel-description-icon-right">verified</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="form-group-container d-inline-flex">
                        <div class="toogle-wrapper">
                            <label>{{ 'AutomatedOffRentAndServiceLabel' | translate }}</label>
                            <por-base-toggle
                                [parentForm]="mandatoryForm"
                                [formControlName]="'automatedOffRentAndService'"
                                [model]="mandatoryForm.value.automatedOffRentAndService"
                                (modelChange)="onModelChange($event, 'automatedOffRentAndService')"></por-base-toggle>
                        </div>
                        <div class="hint-text ml-2">{{ 'AutomatedOffRentAndServiceHintText' | translate }}</div>
                    </div>
                    <div class="form-group-container">
                        <div class="warning-callout">
                            <div class="warning-icon">
                                <i class="material-icons">warning</i>
                            </div>
                            <div class="warning-text">
                                {{ 'AutomatedOffRentAndServiceWarning' | translate }}
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                }
            </mat-accordion>

            <por-base-button (onclick)="onSubmit()" class="theme-button apply-btn" [disabled]="(vanityUrlLoading$ | async) || (uploading$ | async) || false" [featureName]="'admin-save-button-data'">
                {{ 'Save' | translate }}
            </por-base-button>
        </form>
        } @if ((advanceViewTab$ | async) === advanceSetupTabs.imageAds) {
        <por-admin-ad-setting
            [formValues]="$any(mandatoryForm).value"
            [hiddenFeatures]="hiddenFeatures()"
            (submitForm)="onAdSettingSubmit($event)"
            (uploadSuccess)="afterUploadFile($any($event))"></por-admin-ad-setting>
        } @if (isDialogEnabled) {
        <por-app-confirm-dialog [message]="'adminConsumerPortalSetupSuccess' | translate" (confirmed)="isDialogEnabled = false"></por-app-confirm-dialog>
        }
    </div>
</div>
